import {Injectable} from '@angular/core';
import {ToastType} from "./toasts-container.component";

export interface Toast {
  text: string;
  type: ToastType;
  classname?: string;
  delay?: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts: Toast[] = [];

  private show(toast: Toast) {
    this.toasts.push(toast);
  }

  remove(toast: Toast) {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }

  clear() {
    this.toasts.splice(0, this.toasts.length);
  }

  showStandard(text: string) {
    this.show({ text: text, type: ToastType.NORMAL });
  }

  showSuccess(text: string) {
    this.show({ text: text, type: ToastType.SUCCESS, classname: 'bg-success text-light', delay: 5000 });
  }

  showDanger(text: string) {
    this.show({  text: text, type: ToastType.ERROR, classname: 'bg-danger text-light', delay: 5000 });
  }
}
